<template>
    <div class="auth-profile-register-container">
        <div class="info">
            <p class="title">Welcome, {{ userValues.firstName }}!</p>
            <div class="msg">
                <p class="sub-message">
                    We're excited to get you started, but first let's make sure you are headed
                    in the right direction.
                </p>
            </div>
        </div>
        <div class="cta-btns">
            <button
                v-autofocus
                @click="
                    () =>
                        updateProfileOrEventSteps('artist-register-one', 'artist-register-one')
                "
                class="create-artist-profile-btn"
            >
                I'm an Artist
            </button>
            <button @click="onBookerSelect" class="create-venue-profile-btn">
                I want to book Artists
            </button>
        </div>
    </div>
</template>
<script>
    import { useAuth } from '@/composables/auth/useAuth'
    import { attachTrackings } from '@/helpers/trackings'

    export default {
        name: 'AuthProfileRegister',
        setup() {
            const { userValues, updateProfileOrEventSteps } = useAuth()
            return { userValues, updateProfileOrEventSteps }
        },
        methods: {
            onBookerSelect() {
                attachTrackings('ga', 'ab-testing', {
                    url: window.location.href,
                    booker: window.location.href.includes('?booker=true')
                })
                this.updateProfileOrEventSteps('venue-register-one', null, true)
            }
        }
    }
</script>
<style lang="scss" scoped>
    $mobileMax: 600px;

    @media screen and (max-width: $mobileMax) {
        .cta-btns {
            button {
                width: 100% !important;
            }
        }
    }
    .auth-profile-register-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 40px;

        p {
            margin-bottom: 0px;
        }
        button {
            border: none;
        }

        .info {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            gap: 12px;

            .title {
                color: #dedede;
                font-family: Instrument Sans;
                font-size: 38px;
                font-style: normal;
                font-weight: 500;
                line-height: 110%;
                letter-spacing: -0.76px;
            }
            .msg {
                p {
                    color: #8b8b8b;
                    font-family: Instrument Sans;
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 550;
                    line-height: 125%;
                }
                .sub-message {
                    padding-top: 24px;
                }
            }
        }
        .cta-btns {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            gap: 12px;

            button {
                width: 224px;
                display: flex;
                justify-content: center;
                align-items: center;
                text-wrap: nowrap;
                padding: 11px 30px 12px 30px;
                border-radius: 100px;
                color: black;
                font-family: Instrument Sans;
                font-size: 18px;
                font-style: normal;
                font-weight: 550;
                line-height: 120%;
                align-self: stretch;
            }
            .create-artist-profile-btn {
                background: #cdeb09;
            }
            .create-venue-profile-btn {
                background: #ba87ff;
            }
        }
    }
</style>
